import React, { useState, useEffect, createContext, useContext } from 'react';

const INITIAL_VALUES = {
  stage: 0,
  user: null,
  rut: null,
  school: null
};

const StageContext = createContext(INITIAL_VALUES);

export const StageProvider = props => {
  const { children, response = null } = props;
  const [state, setState] = useState(INITIAL_VALUES);

  useEffect(() => {
    if (response && response?.data) {
      const existingData = response.data;
      setState(state => ({
        ...state,
        stage: existingData?.STAGE || 0,
        user: existingData?.USER_ID,
        rut: existingData?.RUT,
        school: existingData?.campaignData?.organization
      }));
      if (existingData?.STAGE) {
        // update local storage
        const USER_STAGE = `userStage-${existingData.RUT || existingData.rut}-${
          response.campaignID
        }`;
        localStorage.setItem(USER_STAGE, existingData.STAGE);
      }
    }
  }, [response]);

  const toNextStage = (userStage = 'userStage-anon') => {
    setState(prevState => {
      const newStage = prevState.stage + 1;
      // Update localStorage after calculating new stage from current state
      localStorage.setItem(userStage, newStage);
      return {
        ...prevState,
        stage: newStage
      };
    });
  };

  const toPrevStage = (userStage = 'userStage-anon') => {
    setState(prevState => {
      const newStage = prevState.stage - 1 < 0 ? 0 : prevState.stage - 1;
      // Update localStorage after calculating new stage from current state
      localStorage.setItem(userStage, newStage);
      return {
        ...prevState,
        stage: newStage
      };
    });
  };

  const updateContext = newContext => {
    setState(prevState => ({
      ...prevState,
      ...newContext
    }));
  };

  return (
    <StageContext.Provider
      value={{
        state,
        updateContext,
        nextStage: toNextStage,
        prevStage: toPrevStage
      }}
    >
      {children}
    </StageContext.Provider>
  );
};

export const StageConsumer = StageContext.Consumer;
export const useStageContext = () => useContext(StageContext);

// const { Provider, Consumer } = createContext(INITIAL_VALUES);
// export class StageProvider extends Component {
//   state = {
//     stage: 0,
//     user: null,
//     rut: null,
//     school: null
//   };

//   toNextStage = async (userStage = 'userStage-anon') => {
//     const { stage } = this.state;
//     const newStage = stage + 1;
//     localStorage.setItem(userStage, newStage);
//     await this.setState(state => ({
//       ...state,
//       stage: state.stage + 1
//     }));
//   };

//   toPrevStage = async (userStage = 'userStage-anon') => {
//     const { stage } = this.state;
//     const newStage = stage - 1;
//     localStorage.setItem(userStage, newStage < 0 ? 0 : newStage);
//     await this.setState(state => ({
//       ...state,
//       stage: state.stage - 1 < 0 ? 0 : state.stage - 1
//     }));
//   };

//   updateContext = async newContext => {
//     await this.setState(state => ({
//       ...state,
//       ...newContext
//     }));
//   };

//   render = () => (
//     <Provider
//       value={{
//         state: this.state,
//         updateContext: this.updateContext,
//         nextStage: this.toNextStage,
//         prevStage: this.toPrevStage
//       }}
//     >
//       {this.props.children}
//     </Provider>
//   );
// }

// export const StageConsumer = Consumer;
